import Vue from 'vue';
import Vuex from 'vuex';

import { application } from './application.store';
import { alert } from './alert.store';
import { account } from './account.store';
import { project } from './project.store';
import { projectSimple } from './projectSimple.store';
import { lookup } from './lookup.store';
import { template } from './template.store';
import { profile } from './profile.store';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: { application, alert, account, project, projectSimple, lookup, template, profile }
});
